export default __webpack_public_path__ + "static/media/Oil2Gas_00.109fbcd6.png";